module.exports = __webpack_public_path__ + "ab58f6cc17444fd5c4e63f685670a212.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/sanitarios taragui.png
// module id = 621
// module chunks = 0